var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "stepForm",
      attrs: { model: _vm.formData, rules: _vm.rules },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { staticClass: "form-step-title", attrs: { span: 24 } },
            [_c("div", { staticClass: "steptitle" }, [_vm._v("Payment")])]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { sm: 24, md: 11 } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "card" },
                  model: {
                    value: _vm.formData.method,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "method", $$v)
                    },
                    expression: "formData.method",
                  },
                },
                [_vm._v("I want to pay with credit card")]
              ),
              _vm._v(" "),
              _vm.formData.method == "card"
                ? _c(
                    "div",
                    [
                      _c("img", {
                        staticClass: "paymentcards",
                        attrs: { src: "/images/cards.svg" },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Card Number", prop: "cardnumber" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "1111 2222 3333 4444" },
                            model: {
                              value: _vm.formData.cardnumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "cardnumber", $$v)
                              },
                              expression: "formData.cardnumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 15 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Exp. Month",
                                    prop: "cardmonth",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "MM", size: "2" },
                                    model: {
                                      value: _vm.formData.cardmonth,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "cardmonth", $$v)
                                      },
                                      expression: "formData.cardmonth",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Exp. Year",
                                    prop: "cardyear",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "YYYY", size: "4" },
                                    model: {
                                      value: _vm.formData.cardyear,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "cardyear", $$v)
                                      },
                                      expression: "formData.cardyear",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "CVV", prop: "cvv" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "123" },
                                    model: {
                                      value: _vm.formData.cvv,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "cvv", $$v)
                                      },
                                      expression: "formData.cvv",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 15 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _vm._v(" Billing Address "),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.billing.address1) +
                                "\n                        " +
                                _vm._s(_vm.billing.address2) +
                                "\n                        " +
                                _vm._s(
                                  _vm.billing.city + ", " + _vm.billing.postcode
                                ) +
                                "\n                        " +
                                _vm._s(_vm.billing.country) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bankpayment-details" },
                        [
                          _c("strong", [_vm._v("Notice")]),
                          _c("BR"),
                          _c("span", { staticStyle: { color: "#f39200" } }, [
                            _vm._v(
                              "The information and address details of the credit\n                        or debit card you will use for payment must match\n                        the information entered (eg issuing address, date of\n                        issue, name of holder, etc.) when it was\n                        issued."
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "bank" },
                  model: {
                    value: _vm.formData["method"],
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "method", $$v)
                    },
                    expression: "formData['method']",
                  },
                },
                [_vm._v("Payment method bank transfer")]
              ),
              _vm._v(" "),
              _vm.formData.method == "bank"
                ? _c(
                    "div",
                    { staticStyle: { width: "100%" } },
                    [
                      _c("div", { staticClass: "banktransfer-note" }, [
                        _vm._v(
                          "\n                    Wire - Electronic Bank Transfer Details\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bankpayment-details" },
                        [
                          _vm._v(
                            "\n                    All payments must be made at:"
                          ),
                          _c("BR"),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              "European Centre for Architecture Art Design and\n                        Urban Studies"
                            ),
                          ]),
                          _c("BR"),
                          _vm._v(" Bank: Allied Irish Bank"),
                          _c("BR"),
                          _vm._v(
                            " Account Number:\n                    07259019 "
                          ),
                          _c("BR"),
                          _vm._v(
                            " IBAN Number: IE86 AIBK 9336 0007 2590\n                    19"
                          ),
                          _c("BR"),
                          _vm._v(" Swift Code: AIB KIE2D"),
                          _c("BR"),
                          _vm._v(" Sort Code:\n                    93-36-00"),
                          _c("BR"),
                          _vm._v(
                            " Bank Address: Sandymount, Dublin 4,\n                    Ireland"
                          ),
                          _c("BR"),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                "\n                            Please send us the bank transfer receipt with\n                            your payment at\n                            "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "mailto:konstadina@europeanarch.eu",
                                  },
                                },
                                [_vm._v("konstadina@europeanarch.eu")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "\n                            Remember to include the reference ID number of\n                            your submission\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "\n                            Entry fee for each submission is\n                            "
                              ),
                              _c("strong", [_vm._v(_vm._s(_vm.payAmount))]),
                              _vm._v(
                                " euro. After we\n                            receive your submission and check all materials\n                            an invoice will be sent to your email.\n                        "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "banktransfer-note" }, [
                        _vm._v(
                          "\n                    Important: Add €25.00 EUR for Bank Service Charges for\n                    wire transfers.\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "bankdocument",
                          attrs: {
                            href: "https://awardapplication.com/pdf/Bank_Transfer_E40U40.pdf",
                            target: "_blank",
                          },
                        },
                        [_vm._v("Download Bank payment details")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 15 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _vm._v(" Billing Address "),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.billing.address1) +
                                "\n                        " +
                                _vm._s(_vm.billing.address2) +
                                "\n                        " +
                                _vm._s(
                                  _vm.billing.city + ", " + _vm.billing.postcode
                                ) +
                                "\n                        " +
                                _vm._s(_vm.billing.country) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { sm: 24, md: { span: 10, offset: 3 } } },
            [
              _c("div", [_vm._v("Purchase summary")]),
              _vm._v(" "),
              _c("div", { staticClass: "billnotice" }, [
                _vm._v("Billed in Euros (€)"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "linebill" }, [
                _c("div", { staticClass: "billtext" }, [
                  _vm._v(
                    "\n                    One submission for Europe 40 under 40 Award\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "billamount" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.payAmount) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "linebill" }, [
                _c("div", { staticClass: "billtext" }, [_vm._v("Total")]),
                _vm._v(" "),
                _c("div", { staticClass: "billamount" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.payAmount) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.formData.method == "card"
                ? _c(
                    "el-button",
                    {
                      staticClass: "form-submit",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("Pay now\n            ")]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "form-submit",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("Complete submission\n            ")]
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "refundpolicy" }, [
                _c(
                  "a",
                  { attrs: { href: "/refund-policy", target: "_blank" } },
                  [_vm._v("Learn about our Refund Policy")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "invoiceto" }, [
                  _vm._v(
                    "\n                    Your invoice will be sent to " +
                      _vm._s(_vm.billing.email) +
                      "\n                "
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-buttons" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }